import { render, staticRenderFns } from "./RejectJob.vue?vue&type=template&id=112885fd"
import script from "./RejectJob.vue?vue&type=script&lang=js"
export * from "./RejectJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports